import { render, staticRenderFns } from "./PpotList.vue?vue&type=template&id=75d0418a&scoped=true&"
import script from "./PpotList.vue?vue&type=script&lang=js&"
export * from "./PpotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d0418a",
  null
  
)

export default component.exports